import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Trash2 } from 'lucide-react';

interface SignaturePadProps {
  onSave: (signatureDataUrl: string) => void;
  onClear: () => void;
}

export default function SignaturePad({ onSave, onClear }: SignaturePadProps) {
  const sigCanvas = useRef<SignatureCanvas>(null);

  const clear = () => {
    sigCanvas.current?.clear();
    onClear();
  };

  const save = () => {
    if (!sigCanvas.current) return;
    if (sigCanvas.current.isEmpty()) {
      onClear();
      return;
    }
    
    try {
      const trimmedCanvas = sigCanvas.current.getTrimmedCanvas();
      const dataUrl = trimmedCanvas.toDataURL('image/png');
      if (dataUrl) {
        onSave(dataUrl);
      }
    } catch (err) {
      console.error("Signature save failed:", err);
      // Fallback to untrimmed if trimming fails
      const dataUrl = sigCanvas.current.getCanvas().toDataURL('image/png');
      onSave(dataUrl);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="border-2 border-dashed border-amber-200 rounded-xl bg-white/50 p-2">
        <SignatureCanvas
          ref={sigCanvas}
          penColor="#451a03"
          canvasProps={{
            className: 'w-full h-48 rounded-lg cursor-crosshair',
            style: { width: '100%', height: '192px' }
          }}
          onEnd={save}
        />
      </div>
      <div className="flex justify-end">
        <button
          onClick={clear}
          className="flex items-center gap-2 text-sm text-amber-700 hover:text-amber-900 transition-colors"
        >
          <Trash2 size={16} />
          清除簽名
        </button>
      </div>
    </div>
  );
}
